module.exports = __webpack_public_path__ + "static/media/cool-icon.bf718600.svg";